import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=6a0b4f66&scoped=true"
import script from "./CustomReports.vue?vue&type=script&lang=js"
export * from "./CustomReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b4f66",
  null
  
)

export default component.exports